module.exports = __webpack_public_path__ + "img/pm.93bdb6c4.svg";